import { Component, h, Prop, Host } from '@stencil/core';
import { AccordionNode } from '../utils';
import ArrowDown from '../../svg-elements/arrow-down';
import { ComponentView } from '../../../../types/types';

@Component({
  tag: 'rtr-accordion-template',
  styleUrl: 'style-default.sass',
  shadow: false,
})
export class RtrAccordionTemplate {
  @Prop() nodesObject: AccordionNode;
  @Prop() nodeIndex: number;
  @Prop() openedIndex: number;
  @Prop() view: ComponentView;
  @Prop() onOpenIndex: (index: number) => void;

  render() {
    const currentOpened = this.nodeIndex === this.openedIndex;
    const hideRow = currentOpened && this.nodesObject.hideCollapsedOnExpanded;

    return (
      <Host
        class={{
          RACollapsibleContainer: true, //
          RACollapsibleClean: this.view === ComponentView.Checkout,
          RACollapsibleOpened: currentOpened,
        }}
      >
        <div class={{ RACollapsibleRow: true, RACollapsibleRowHidden: hideRow }} onClick={() => this.onOpenIndex(this.nodeIndex)}>
          {this.nodesObject.collapsed}
          <div class="RAArrowWrapper">
            <div class="RAArrow">
              <ArrowDown />
            </div>
          </div>
        </div>
        <div class={{ RAContent: true, RAContentExpanded: currentOpened }}>{this.nodesObject.expanded}</div>
      </Host>
    );
  }
}
